import { defineStore } from "pinia";

export const useResponsiveStore = defineStore("responsive", {
  state: () => ({
    height: 0,
    width: 0,
    name: "",
    isChanged: false,
    isXs: false,
    isSm: false,
    isMd: false,
    isLg: false,
    isXl: false,
    is2xl: false,

    smAndDown: false,
    smAndUp: false,
    mdAndDown: false,
    mdAndUp: false,
    lgAndDown: false,
    lgAndUp: false,
    xlAndDown: false,
    xlAndUp: false,

    sm: 640,
    md: 768,
    lg: 1024,
    xl: 1280,
    the2xl: 1536,
  }),
  actions: {
    setStates(data: any) {
      this.isChanged = data.isChanged;
      this.height = data.height;
      this.width = data.width;
      this.name = data.name;
      this.isXs = data.isXs;
      this.isSm = data.isSm;
      this.isMd = data.isMd;
      this.isLg = data.isLg;
      this.isXl = data.isXl;
      this.is2xl = data.is2xl;
      this.smAndDown = data.smAndDown;
      this.smAndUp = data.smAndUp;
      this.mdAndDown = data.mdAndDown;
      this.mdAndUp = data.mdAndUp;
      this.lgAndDown = data.lgAndDown;
      this.lgAndUp = data.lgAndUp;
      this.xlAndDown = data.xlAndDown;
      this.xlAndUp = data.xlAndUp;
      this.sm = data.sm;
      this.md = data.md;
      this.lg = data.lg;
      this.xl = data.xl;
      this.the2xl = data.the2xl;
    },
  },
});
